export const presenceActionTypes = {
    PRESENCE_GET_EVENTS_BEGIN: 'PRESENCE_GET_EVENTS_BEGIN',
    PRESENCE_GET_EVENTS_SUCCESS: 'PRESENCE_GET_EVENTS_SUCCESS',
    PRESENCE_GET_EVENTS_FAILURE: 'PRESENCE_GET_EVENTS_FAILURE',
    PRESENCE_GET_EVENT_BEGIN: 'PRESENCE_GET_EVENT_BEGIN',
    PRESENCE_GET_EVENT_SUCCESS: 'PRESENCE_GET_EVENT_SUCCESS',
    PRESENCE_GET_EVENT_FAILURE: 'PRESENCE_GET_EVENT_FAILURE',
    PRESENCE_MARK_LOCAL_PRESENT: 'PRESENCE_MARK_LOCAL_PRESENT',
    PRESENCE_ADD_LOCAL_USER: 'PRESENCE_ADD_LOCAL_USER',
}

const initialState = {
    loading: false,
    list: [],
    currentEvent: [],
}

export default (state = initialState, action) => {
    switch(action.type) {
        case presenceActionTypes.PRESENCE_GET_EVENTS_BEGIN:
        case presenceActionTypes.PRESENCE_GET_EVENT_BEGIN:
            return { ...state, loading: true };
        case presenceActionTypes.PRESENCE_GET_EVENTS_SUCCESS:
            return { ...state, loading: false, list: action.data }
        case presenceActionTypes.PRESENCE_GET_EVENTS_FAILURE:
        case presenceActionTypes.PRESENCE_GET_EVENT_FAILURE:
            return { ...state, loading: false }
        case presenceActionTypes.PRESENCE_GET_EVENT_SUCCESS:
            return { ...state, loading: false, currentEvent: action.data }
        case presenceActionTypes.PRESENCE_MARK_LOCAL_PRESENT:
            const presenceIndex = state.currentEvent.findIndex(presence => presence.user.id === action.userId)
            return { ...state, currentEvent: [ 
                ...state.currentEvent.slice(0, presenceIndex),
                { ...state.currentEvent[presenceIndex], present: action.present },
                ...state.currentEvent.slice(presenceIndex + 1),
            ] }
        case presenceActionTypes.PRESENCE_ADD_LOCAL_USER:
            const eventIndex = state.list.findIndex(event => event.id === action.eventId)
            console.log(eventIndex)
            return {
                ...state,
                currentEvent: [ ...state.currentEvent, { present: true, user: action.user } ],
                list: [
                    ...state.list.slice(0, eventIndex),
                    { ...state.list[eventIndex], subscribedNumber: state.list[eventIndex].subscribedNumber + 1 },
                    ...state.list.slice(eventIndex + 1),
                ]
            }
        default:
            return state;
    }
}


// WEBPACK FOOTER //
// ./src/features/presence/redux/reducer.js